/**
 * URL of the shell's master-mux WebSocket. It derives from the same API base
 * the HTTP client uses (`getApiOrigin`: `?url=` → `formica.api.baseUrl` →
 * `window.__API_URL__` → `VITE_API_URL` → page host on :7680) and is meant to
 * be read at connect time, never captured once: the user may pick another
 * server on the login page (I-2833).
 */
import { getApiOrigin } from '@blpde/connect';
import { SHELL_DEVICE_TYPE } from '@/notificationDeviceSettings';

/**
 * `ws(s)://<api origin>/v1/mux/ws?deviceType=browser` for the API base
 * configured right now. The device type is what master filters the socket's
 * notification pushes by (the settings for the browser; a session bound to a
 * browser device at the login is one anyway).
 */
export function muxUrl(): string {
  // Master's REST and mux endpoints both sit under `/v1`.
  return `${getApiOrigin().replace(/^http/i, 'ws')}/v1/mux/ws?deviceType=${SHELL_DEVICE_TYPE}`;
}
